import React from 'react'
import {
    Box,
    Link,
    Text,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {EGIFT_CARD_BALANCE_CHECK_URL} from '../../../constants'
import {FormattedMessage} from 'react-intl'
const CardCheckBalance = () => {
    const styles = useMultiStyleConfig('GiftCertificate')
    return (
        <Box className="already-gift-card" {...styles.rightBox.balanceCheck.main}>
            <Text {...styles.rightBox.balanceCheck.label}>
                <FormattedMessage
                    id="eGiftCard.already.have"
                    defaultMessage="Already have a gift card?"
                />
            </Text>
            <Link {...styles.rightBox.balanceCheck.link} href={EGIFT_CARD_BALANCE_CHECK_URL}>
                <FormattedMessage id="eGiftCard.check.balance" defaultMessage="Check Balance" />
            </Link>
        </Box>
    )
}

export default CardCheckBalance
